import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const facet9 = css`

    .image__facet-9 {
        ::slotted(img), ::slotted(picture) {
            object-fit: cover;
            clip-path: polygon( 50% 0%,50% 0%,41.89% 0.654%,34.197% 2.549%,27.023% 5.581%,20.471% 9.648%,14.645% 14.645%,9.648% 20.471%,5.581% 27.023%,2.549% 34.197%,0.654% 41.89%,0% 50%,0% 50%,0% 50.113%,0.001% 50.227%,0.002% 50.34%,0.003% 50.453%,0.005% 50.566%,0.006% 50.679%,0.008% 50.792%,0.01% 50.905%,0.013% 51.019%,0.015% 51.132%,0% 51.132%,0% 100%,50% 100%,50% 100%,58.11% 99.346%,65.803% 97.451%,72.977% 94.419%,79.529% 90.352%,85.355% 85.355%,90.352% 79.529%,94.419% 72.977%,97.451% 65.803%,99.346% 58.11%,100% 50%,100% 50%,99.346% 41.89%,97.451% 34.197%,94.419% 27.023%,90.352% 20.471%,85.355% 14.645%,79.529% 9.648%,72.977% 5.581%,65.803% 2.549%,58.11% 0.654%,50% 0% );            
            aspect-ratio: 1;
            width: 100%;
            height: auto;
            z-index: 4;
        }
        .image-shapes-9 {
            display: block;
        }
        .image-shapes-9--crop-mobile {
            display: none;
        }
    }

    .image__facet-9--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            aspect-ratio:  4 / 3;
            clip-path: polygon( 5.853% 0%,5.853% 0%,4.782% 2.899%,3.81% 5.875%,2.942% 8.923%,2.18% 12.04%,1.526% 15.222%,0.985% 18.465%,0.559% 21.764%,0.25% 25.115%,0.063% 28.516%,0% 31.96%,0% 31.96%,0% 32.115%,0.001% 32.269%,0.002% 32.423%,0.003% 32.577%,0.004% 32.73%,0.006% 32.884%,0.008% 33.038%,0.01% 33.192%,0.013% 33.346%,0.016% 33.501%,0% 33.501%,0% 100%,50% 100%,50% 100%,58.11% 99.109%,65.804% 96.531%,72.978% 92.405%,79.529% 86.872%,85.355% 80.072%,90.353% 72.144%,94.419% 63.228%,97.451% 53.466%,99.346% 42.997%,100% 31.96%,100% 31.96%,99.937% 28.516%,99.75% 25.115%,99.441% 21.764%,99.015% 18.465%,98.474% 15.222%,97.82% 12.04%,97.058% 8.923%,96.19% 5.875%,95.218% 2.899%,94.147% 0%,5.853% 0% );
        }
        .image-shapes-9 {
            display: none;
        }
        .image-shapes-9--crop-mobile {
            display: block;
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                aspect-ratio: 1;
                clip-path: polygon( 50% 0%,50% 0%,41.89% 0.654%,34.197% 2.549%,27.023% 5.581%,20.471% 9.648%,14.645% 14.645%,9.648% 20.471%,5.581% 27.023%,2.549% 34.197%,0.654% 41.89%,0% 50%,0% 50%,0% 50.113%,0.001% 50.227%,0.002% 50.34%,0.003% 50.453%,0.005% 50.566%,0.006% 50.679%,0.008% 50.792%,0.01% 50.905%,0.013% 51.019%,0.015% 51.132%,0% 51.132%,0% 100%,50% 100%,50% 100%,58.11% 99.346%,65.803% 97.451%,72.977% 94.419%,79.529% 90.352%,85.355% 85.355%,90.352% 79.529%,94.419% 72.977%,97.451% 65.803%,99.346% 58.11%,100% 50%,100% 50%,99.346% 41.89%,97.451% 34.197%,94.419% 27.023%,90.352% 20.471%,85.355% 14.645%,79.529% 9.648%,72.977% 5.581%,65.803% 2.549%,58.11% 0.654%,50% 0% );
            }
            .image-shapes-9 {
                display: block;
            }
            .image-shapes-9--crop-mobile {
                display: none;
            }
        }
    }

    .image-shapes-9 {
        position: absolute;
        top: 0;
        left: -13.6%;
        width: 141%;
        height: auto;
        z-index: 5;
    }

    .image-shapes-9--crop-mobile {
        position: absolute;
        top: 2%;
        left: 0px;
        width: 113.5%;
        height: auto;
        z-index: 5;
    }
`;